/* @flow */
import Checkbox from 'components/Checkbox.jsx';
import createChainedFunction from 'utils/createChainedFunction';
import doWhileMounted from 'utils/doWhileMounted';
import Field from 'components/Field.jsx';
import Formsy from 'lib/Formsy';
import React from 'react';

const FormCheckBox = React.createClass({
  mixins: [Formsy.Mixin],

  onChange(event) {
    this.setValue(event.target.checked);
  },

  /* This is for autofill purposes.
   * Some browsers does not emit change event when
   * they fill out the forms, so formzy is not aware
   * the value change and the validation does not run.
   * This pulls the value from the DOM at
   * regular interval and if what is found is different
   * than what formzy currently have then we tell formzy
   * about this new value via the formzy mixin.
   */
  lookForChanges() {
    if (!this.refs.input) {
      return;
    }

    const checked = this.refs.input.isChecked();
    if (checked !== this.getValue()) {
      this.setValue(checked);
    }
  },

  render() {
    const errorMessage = this.getErrorMessage();

    return (
      <Field error={errorMessage}>
        <Checkbox
          {...this.props}
          ref="input"
          onChange={createChainedFunction(this.props.onChange, this.onChange)}
        />
      </Field>
    );
  },
});

export default doWhileMounted(FormCheckBox, 'lookForChanges', 1000);



// WEBPACK FOOTER //
// ./src/components/FormCheckBox.jsx